import React, { useState } from 'react';
import File from "assets/svgs/File.svg";
import { formatFileSize, getDisplayedFileName, downloadFile } from 'utils';

function FileBubble({ downloadHref, type, fileName, fileSize }) {
  const [downloading, setDownloading] = useState(false);
  const [progress, setProgress] = useState(0);

  const handleDownload = async (event) => {
    event.preventDefault();
    
    try {
      setDownloading(true);
      setProgress(0);
      
      await downloadFile(downloadHref, fileName, (progressValue) => {
        setProgress(progressValue);
      });
      
      setDownloading(false);
      
      // Clear state after a short delay
      setTimeout(() => {
        setProgress(0);
      }, 1000);
    } catch (error) {
      console.error('Download failed:', error);
      setDownloading(false);
      setProgress(0);
      // Fallback to direct download
    window.location.href = downloadHref;
    }
  };

  return (
    <a onClick={handleDownload} target='_blank' download={fileName} className="block">
    <div className={`flex gap-4 items-center p-8 rounded-tr-xl 
        shadow-md rounded-br-xl rounded-bl-xl ${type === 'send' ? 'bg-white' : 'bg-secondary'} 
        ${downloading ? 'opacity-75 cursor-wait' : 'cursor-pointer'} transition-opacity relative`}>
      <span className={`${type === 'send' ? 'bg-secondary' : 'bg-white'} p-2 w-[40px] h-[40px] rounded-md flex items-center justify-center`}>
          {downloading ? (
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          ) : (
        <img src={File} alt="File Icon" />
          )}
      </span>
        <div className="flex-column flex-1">
          <span className="font-[600] text-base text-black">{getDisplayedFileName(fileName, 25)}</span>
        <span className="text-sm text-darkGray">{formatFileSize(fileSize)}</span>
          {downloading && (
            <div className="mt-2 w-full">
              <div className="w-full bg-gray-200 rounded-full h-1.5 overflow-hidden">
                <div
                  className="bg-primary h-1.5 rounded-full transition-all duration-300 ease-out"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <span className="text-xs text-primary font-semibold mt-1">{progress}%</span>
            </div>
          )}
      </div>
    </div>
    </a>
  );
}

export default FileBubble;
